export default abstract class HasLabel {
    getLabel(long: boolean = false): string {
        return this.toString(long);
    }

    /**
     * Optional HTML appended after the plain-text label, but only in callers
     * that render the label through v-html (e.g. SearchComponent's option
     * templates). Returns "" by default so escaped-text callers stay clean.
     */
    getLabelSuffixHtml(): string {
        return "";
    }

    abstract toString(long?: boolean): string;
}
